import { NodeEnv } from 'common/src/nodeEnv';

export function showDeprecationWarning(deprecatedComponent: string, replacementComponent: string) {
    if (process.env.NODE_ENV !== NodeEnv.Production) {
        console.warn(
            `Component ${deprecatedComponent} is deprecated, use ${replacementComponent} instead.`
        );
    }
}
